import { Book, API, Project } from '@brg/api';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';
import styled from 'styled-components';
import { AppTester } from 'supporting';

const Title = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit?.header?.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

const Wrapper = styled.a`
    display: inline-block;
    cursor: pointer;

    ${Title} {
        margin-right: 4px;
    }

    svg {
        margin-bottom: 2px;
    }
`;

export const MainBookTitle: FC<{ book: Book | Project }> = ({ book }) => {
    //@ts-ignore
    const title = API.toLang(book?.book?.title) || 'Unnamed';
    const isPreview = useRouteMatch(['/book-preview', '/books/preview/']);
    const isMediaBook = AppTester.isDeziiign() && AppTester.isContext('booksmediiia')
    const isArtMediiia = AppTester.isDeziiign() && AppTester.isContext('artmediiia');

    const href = useMemo(() => {
        if (isMediaBook) {
           return `/mediiiabooks${isPreview ? CreateLinkTo.bookPreview(book?.bookId) : CreateLinkTo.book(book?.bookId)}`
        }

        if (isArtMediiia) {
            return `/art${isPreview ? CreateLinkTo.bookPreview(book?.bookId) : CreateLinkTo.book(book?.bookId)}`
        }

        return isPreview ? CreateLinkTo.bookPreview(book?.bookId) : CreateLinkTo.book(book?.bookId)
    } , [book])

    if (!book) {
        return null;
    }

    return (
        <FlexBox >
            <Wrapper href={href}>
                <Title>{title as string}</Title>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12.1897L4.81106 13L10.8719 6.94475L10.8719 11.6151L12 11.6077L12 5.00737L5.38618 5L5.39355 6.1418L10.0608 6.13444L4 12.1897Z" fill="#909090"/>
                </svg>
            </Wrapper>
    </FlexBox>
    )
}import { Book, API, Project } from '@brg/api';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';
import styled from 'styled-components';
import { AppTester } from 'supporting';

const Title = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.projectEdit?.header?.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

const Wrapper = styled.a`
    display: inline-block;
    cursor: pointer;

    ${Title} {
        margin-right: 4px;
    }

    svg {
        margin-bottom: 2px;
    }
`;

export const MainBookTitle: FC<{ book: Book | Project }> = ({ book }) => {
    //@ts-ignore
    const title = API.toLang(book?.book?.title) || 'Unnamed';
    const isPreview = useRouteMatch(['/book-preview', '/books/preview/']);
    const isMediaBook = AppTester.isDeziiign() && AppTester.isContext('booksmediiia')
    const isArtMediiia = AppTester.isDeziiign() && AppTester.isContext('artmediiia');

    const href = useMemo(() => {
        if (isMediaBook) {
           return `/mediiiabooks${isPreview ? CreateLinkTo.bookPreview(book?.bookId) : CreateLinkTo.book(book?.bookId)}`
        }

        if (isArtMediiia) {
            return `/art${isPreview ? CreateLinkTo.bookPreview(book?.bookId) : CreateLinkTo.book(book?.bookId)}`
        }

        return isPreview ? CreateLinkTo.bookPreview(book?.bookId) : CreateLinkTo.book(book?.bookId)
    } , [book])

    if (!book) {
        return null;
    }

    return (
        <FlexBox >
            <Wrapper href={href}>
                <Title>{title as string}</Title>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12.1897L4.81106 13L10.8719 6.94475L10.8719 11.6151L12 11.6077L12 5.00737L5.38618 5L5.39355 6.1418L10.0608 6.13444L4 12.1897Z" fill="#909090"/>
                </svg>
            </Wrapper>
    </FlexBox>
    )
}